import { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { EMAIL_PREFERENCES_ROUTE, USER_PROFILE_ROUTE } from '../../Constants';
import './UserAccountHeader.scss';

function UserAccountHeader(): ReactElement {
  const active = ({ isActive }) => (isActive ? 'active' : 'inactive');

  return (
    <div className="cs-user-account-header-ctx">
      <div className="content">
        <NavLink className="link account" to="/user/profile">
          My Account
        </NavLink>
        <div className="separator" />
        <NavLink to={USER_PROFILE_ROUTE} className={active}>
          Profile
        </NavLink>
        <NavLink to={EMAIL_PREFERENCES_ROUTE} className={active}>
          Email Preferences
        </NavLink>
      </div>
    </div>
  );
}

export default UserAccountHeader;
